/**
 * SRV-F1-5: Procurement Request Section
 *
 * ⚠️ Sprint 23 W2 D-1 SCOPE-LOCK: temporarily renders nothing.
 * The old `/service/procurement-requests/*` backend was deleted Sprint 22c W1 D-1
 * (commit 802d992e, Q-J004-15 ServiceProcurementRequest DELETE & REPLACE ratify).
 * The new E-126 backend ships at `/api/v1/procurement-requests` with a different
 * shape (productId UUID FK + source=WORKSHEET + DRAFT/SUBMITTED state-machine).
 *
 * Full rewrite scheduled S-126-04 sub-slices 4a-4f (Sprint 23 W2 D-2..W3 D-2,
 * ~5.5 SP). Until then this section hides to avoid showing a permanently-empty
 * UI backed by silent 404s. See:
 *   _bmad-output/reports/sprint-23-w2-d1-s-126-04-scope-lock-2026-05-17.md
 */

interface ProcurementRequestSectionProps {
  worksheetId: string;
  isEditable: boolean;
}

export function ProcurementRequestSection(_props: ProcurementRequestSectionProps): null {
  return null;
}
